var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',_vm._g(_vm._b({ref:"campo",attrs:{"items":_vm.impostos,"return-object":""}},'v-combobox',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }